<template>
  <div class="graph-canvas-component">
    <canvas
      class="lineGraphCanvas"
      :width="$props.canvasWidth * $props.scale"
      :height="$props.canvasHeight * $props.scale"
      :style="`width: ${$props.canvasWidth}px; height: ${$props.canvasHeight}px`"
    >
    </canvas>
    <canvas
      class="barGraphCanvas"
      :width="$props.canvasWidth * $props.scale"
      :height="$props.canvasHeight * $props.scale"
      :style="`width: ${$props.canvasWidth}px; height: ${$props.canvasHeight}px`"
    >
    </canvas>
  </div>
</template>

<script>
export default {
  props: {
    canvasWidth: Number,
    canvasHeight: Number,
    scale: Number,
  },
};
</script>

<style lang="scss" scoped>
.graph-canvas-component {
  position: absolute;
  bottom: 20px;
  right: 23px;
  display: flex;

  @include spLandscape {
    display: none;
  }
}

.barGraphCanvas {
  flex: 0 0 auto;
  margin-left: 37.5px;
  // widthとheightは_canvasWidth, _canvasHeight内で決定

  @include sp {
    display: none;
  }
}

.lineGraphCanvas {
  flex: 0 0 auto;
  // widthとheightは_canvasWidth, _canvasHeight内で決定

  @include tb {
    display: none;
  }

  @include sp {
    display: none;
  }
}
</style>
